import styles from "./QuestionText.module.css";

interface QuestionTextProps {
	value: string;
	onChange: (value: string) => void;
	placeholder: string;
}

export function QuestionText({
	value,
	onChange,
	placeholder,
}: QuestionTextProps) {
	return (
		<textarea
			className={styles.textarea}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			placeholder={placeholder}
		/>
	);
}
